import React from 'react';

import './LoginOauth.scss';

export const LoginOauth = () => {
  return (
    <div className='oauth-button-container'>
      <div className='oauth-divider'>
        <span>of</span>
      </div>
      <button type='button' className='oauth-btn'>
        <img src='icons/google-logo.svg' alt='Google' />
        Log in met Google
      </button>
      <button type='button' className='oauth-btn'>
        <img src='icons/microsoft-logo.svg' alt='Microsoft' />
        Log in met Microsoft
      </button>
    </div>
  );
};
